// initial state
import bus from '@/EventBus'
import PermanentPointService from "../../services/PermanentPointService";
import LocationService from "../../services/LocationService";

const state = {
    currentPermanentPoint: null,
}

// actions
const actions = {
    createPermanentPoint({ commit, state }, { currentPermanentPoint }) {
        commit('SET_CURRENT_PERMANENT_POINT', currentPermanentPoint)
        return PermanentPointService.create(state.currentPermanentPoint).then((res) =>
            console.log(res)
        )
    },

    findLocation({ commit, state }, { currentPermanentPoint }) {
        commit('SET_CURRENT_PERMANENT_POINT', currentPermanentPoint)
        return LocationService.find(state.currentPermanentPoint)
    },

    search({ commit }, text) {
        commit('SET_PERMANENT_POINT_SEARCH_TEXT', text)
        bus.$emit('permanenet-point-search')
    },

    setInitialPermanentPoint({ commit }, user) {
        commit('SET_CURRENT_PERMANENT_POINT', {
            creator: user.id,
            broker: user.name,
            country: 'PL'
        })
    },

    setCurrentPermanentPoint({ commit }, currentPermanentPoint) {
        if (currentPermanentPoint) {
            return PermanentPointService.find(currentPermanentPoint.id).then((res) => {
                commit('SET_CURRENT_PERMANENT_POINT', PermanentPointFromCollectionResponse(res));
            })
        }
    },

    updatePermanentPoint({ commit, state }, currentPermanentPoint) {
        return PermanentPointService.update(state.currentPermanentPoint);
    },

}

const PermanentPointFromCollectionResponse = (res) => {
    const data = res.data['hydra:member'] || res.data['member'] || res.data
    return Array.isArray(data) ? data[0] : data
}

// mutations
const mutations = {
    SET_CURRENT_PERMANENT_POINT(state, currentPermanentPoint) {
        state.currentPermanentPoint = Object.assign({}, currentPermanentPoint) // remove reference
    },

    SET_PERMANENT_POINT_SEARCH_TEXT(state, text) {
        state.searchText = text
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}